import { useContext, useEffect, useState } from 'react';
import { Trans } from '@lingui/react';
import validator from 'validator';
import { admitUserOnProfile, getUsersOfProfile } from '../../../Service/restapi/authService';
import { LoadingAnimation } from '../../../Service/ResourceAdapter';
import { TransButtonDefault, TransButtonLink, TransButtonPrimaryWithSpinner } from '../../../Atoms/Buttons';
import { ModalDialog, useModalState } from '../../../Molecules/Dialogs';
import { TransTextInputField } from '../../../Atoms/InputFields';
import { ProfileContext } from '../../../Service/Context/ProfileContext';
import { ProfileShareActions } from './ProfileShareActions';
import PanePaper from '../../../Molecules/PanePaper';
import BookitupAddIcon from '../../../Atoms/BookitupAddIcon';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import { LicenceS } from '../../../Service/LicenceS';
import { Divider, Group, Text } from '@mantine/core';

// eslint-disable-next-line import/prefer-default-export
export const ShareProfile = () => {
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  const [sharedUser, setSharedUser] = useState(undefined);
  const { show, toggle } = useModalState(false);
  const [emailNewShare, setEmailNewShare] = useState('');
  const [loadingShareProfile, setLoadingShareProfile] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);

  const { isOwnProfile: isOwner } = useContext(ProfileContext);

  useEffect(() => {
    setEmailNewShare('');
    setLoadingShareProfile(false);
  }, [show]);

  useEffect(() => {
    loadProfileShares();
  }, []);

  function loadProfileShares() {
    getUsersOfProfile().then((resp) => {
      if (resp.ok) {
        resp.json().then((userEmails) => {
          setSharedUser(userEmails);
        });
      }
    });
  }

  function shareProfile() {
    if (!validator.isEmail(emailNewShare)) {
      setInvalidEmail(true);
    } else {
      setLoadingShareProfile(true);
      admitUserOnProfile(emailNewShare)
        .then((resp) => {
          if (resp.ok) {
            resp.json().then((newSharedUsers) => {
              setSharedUser(newSharedUsers);
            });
          } else {
            console.error(`could not share profile with ${emailNewShare}`);
          }
        })
        .catch((error) => {
          console.error({ error });
          console.error(`could not share profile with ${emailNewShare}`);
        })
        .finally(() => {
          setLoadingShareProfile(false);
          toggle();
        });
    }
  }

  if (!sharedUser) {
    return <LoadingAnimation />;
  }

  const styles = {
    actions: {
      marginBottom: 5,
      display: 'flex',
      justifyContent: 'flex-end',
    },
    list: {
      backgroundColor: 'white',
      borderRadius: 5,
      paddingTop: 5,
      paddingBottom: 5,
    },
    itemContainer: {
      marginBottom: 5,
      display: 'flex',
    },
    description: {
      color: '#666666',
      marginBottom: 20,
      fontSize: 12,
    },
  };

  const users = [];
  sharedUser.map((email, index) => {
    users.push(
      <Group position="apart" mt={5}>
        <Text>{email}</Text>
        <ProfileShareActions email={email} reloadProfileShares={loadProfileShares} />
      </Group>,
    );
  });

  return (
    <PanePaper
      title="profile.shares"
      tooltip="help.settings.profile.shares.pane"
      rightSection={
        isOwner && (
          <BookitupAddIcon onClick={() => executeWithLicenceCheck(LicenceS.Restrictions.SHARE_PROFILE, toggle)} />
        )
      }
    >
      <Text size="xs">
        Wenn du Mitarbeiter hast, kannst Du für sie hier einen Zugang erstellen. Sie erhalten dann vollen Zugriff, sowie
        alle E-Mail-Benachrichtigungen, wie der Haupt-Account.
      </Text>
      {isOwner && (
        <>
          {sharedUser.length === 0 && <Text size="xs">Dieses Profil ist mit niemandem geteilt.</Text>}
          {sharedUser.length > 0 && (
            <>
              <Text size="xs" mt="md">
                Folgenden Nutzern ist der Zugriff auf dieses Profil freigegeben:
              </Text>
              <Divider my="md" />
              {users}
            </>
          )}
          <ModalDialog
            header={<Trans id="Profil teilen" />}
            body={
              <>
                <div style={styles.description}>
                  Gib die E-Mail-Adresse der Person ein, die auf dieses Profil Zugriff erhalten soll. Falls unter dieser
                  E-Mail-Adresse noch kein bookitup Konto existiert, wird automatisch ein Zugang erstellt und der Person
                  per E-Mail zugeschickt.
                </div>
                <TransTextInputField
                  onChange={(e) => {
                    setEmailNewShare(e.target.value);
                  }}
                  name="email"
                  value={emailNewShare}
                  placeholder="contact.email"
                />

                {invalidEmail && <div style={{ color: 'red' }}>Gib eine gültige E-Mail-Adresse ein.</div>}

                <div style={styles.description}>
                  Die Freigabe kannst Du jederzeit wieder auflösen. Nur Du, als Admin des Profils, kannst weitere
                  Freigaben einrichten.
                </div>
              </>
            }
            footer={
              <>
                <TransButtonPrimaryWithSpinner
                  isLoading={loadingShareProfile}
                  onClickHandler={shareProfile}
                  text="Profil freigeben"
                />
                &nbsp;
                <TransButtonDefault onClickHandler={toggle} text="actions.cancel" />
              </>
            }
            show={show}
            toggle={toggle}
          />
        </>
      )}
      {!isOwner && <div>Profile freigeben, kann nur der Administrator von dem Profil.</div>}
    </PanePaper>
  );
};
